import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Collapse,
  Drawer,
  IconButton,
  Stack,
  Tab,
  Tabs,
  Typography,
  Divider,
  FormControl,
  Tooltip,
  Avatar,
  InputLabel,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Grid,
  MenuItem,
  Paper,
  Select,
  alpha,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material'
import ExpandMore from '@mui/icons-material/ExpandMore'
import ExpandLess from '@mui/icons-material/ExpandLess'
import Business from '@mui/icons-material/Business'
import LocationOn from '@mui/icons-material/LocationOn'
import Settings from '@mui/icons-material/Settings'
import CalendarToday from '@mui/icons-material/CalendarToday'
import Schedule from '@mui/icons-material/Schedule'
import People from '@mui/icons-material/People'
import ManageAccounts from '@mui/icons-material/ManageAccounts'
import Forum from '@mui/icons-material/Forum'
import LocalHospital from '@mui/icons-material/LocalHospital'
import ClinicPeopleManagerDrawer from './ClinicPeopleManagerDrawer'
import VideoCall from '@mui/icons-material/VideoCall'
import Receipt from '@mui/icons-material/Receipt'
import TrendingUp from '@mui/icons-material/TrendingUp'
import Assignment from '@mui/icons-material/Assignment'
import Close from '@mui/icons-material/Close'
import Phone from '@mui/icons-material/Phone'
import Email from '@mui/icons-material/Email'
import Badge from '@mui/icons-material/Badge'
import MedicalServices from '@mui/icons-material/MedicalServices'
import Tv from '@mui/icons-material/Tv'
import MonitorIcon from '@mui/icons-material/Monitor'
import Psychology from '@mui/icons-material/Psychology'
import PersonSearch from '@mui/icons-material/PersonSearch'
import GroupIcon from '@mui/icons-material/Group'
import Info from '@mui/icons-material/Info'
import Home from '@mui/icons-material/Home'
import ContactPhone from '@mui/icons-material/ContactPhone'
import OpenInNew from '@mui/icons-material/OpenInNew'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { toast } from 'react-toastify'
import { ChamberRoomsExpansion } from 'src/supportPortal/components/common/clinics/chamberRooms'
import ClinicBrandCommunicationsDrawer from 'src/supportPortal/components/common/clinics/ClinicBrandCommunicationsDrawer'
import ClinicBrandCommsQuotaDialog from 'src/supportPortal/components/common/clinics/ClinicBrandCommsQuotaDialog'
import OohScreensDrawer from 'src/supportPortal/views/clinics/oohManagement/OohScreensDrawer'
import KioskScreensDrawer from 'src/supportPortal/views/clinics/oohManagement/KioskScreensDrawer'
import { useNavigate, useLocation } from 'react-router-dom'
import { getSPDataWithParams } from 'src/supportPortal/services/services'
import {
  getDataMapFromCommonResponse,
  getMessageMapFromCommonResponse,
  isCommonResponseSuccessfulV2,
} from 'src/mentor/helpers/utilityFunctions'
import { getImageLink } from 'src/mentor/helpers/utilityFunctions'
import SupportHeader from 'src/supportPortal/layout/SupportHeader'
import { styled } from '@mui/material/styles'
import { APP_CONSTANTS } from 'src/consumer/constants'
import { getClinicPublicallyListableEvents } from 'src/clinic/components/ClinicBrandPages/utils'
import { getAllRolesInBoolean } from 'src/mentor/layout/utils'
import {
  AFFILIATION_BELONGS_TO_AUMHUM_NETWORK,
  AFFILIATION_BELONGS_TO_CLINIC,
  getSupportClinicBrandBySlug,
  updateSupportClinicPractitionerAffiliation,
} from 'src/supportPortal/services/clinicPractitionerAffiliationService'

// Soothing accent colors for brands (subtle borders and accents)
const brandAccentColors = [
  { border: '#667eea', accent: '#667eea15', icon: '#667eea' },
  { border: '#f093fb', accent: '#f093fb15', icon: '#f093fb' },
  { border: '#4facfe', accent: '#4facfe15', icon: '#4facfe' },
  { border: '#43e97b', accent: '#43e97b15', icon: '#43e97b' },
  { border: '#fa709a', accent: '#fa709a15', icon: '#fa709a' },
  { border: '#30cfd0', accent: '#30cfd015', icon: '#30cfd0' },
  { border: '#a8edea', accent: '#a8edea15', icon: '#a8edea' },
  { border: '#ff9a9e', accent: '#ff9a9e15', icon: '#ff9a9e' },
]

const PRACTITIONER_AFFILIATION_SCOPE_BRAND = 'brand'
const PRACTITIONER_AFFILIATION_SCOPE_LOCATION = 'location'

const StyledBrandCard = styled(Card, {
  shouldForwardProp: (prop) => prop !== 'accentColor',
})(({ theme, accentColor }) => ({
  marginBottom: theme.spacing(2.5),
  borderRadius: theme.spacing(2.5),
  backgroundColor: theme.palette.background.paper,
  border: `2px solid ${accentColor.border}40`,
  borderLeft: `4px solid ${accentColor.border}`,
  boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  overflow: 'hidden',
  position: 'relative',
  '&:hover': {
    boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
    transform: 'translateY(-2px)',
    borderColor: `${accentColor.border}80`,
  },
}))

const StyledLocationCard = styled(Card)(({ theme }) => ({
  marginBottom: theme.spacing(1.5),
  borderRadius: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  border: `2px solid ${theme.palette.grey[200]}`,
  transition: 'all 0.3s ease',
  '&:hover': {
    borderColor: theme.palette.primary.main,
    boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
    transform: 'translateX(4px)',
  },
}))

const ActionButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  borderRadius: theme.spacing(1.5),
  padding: theme.spacing(0.875, 2),
  fontSize: '0.875rem',
  fontWeight: 600,
  boxShadow: 'none',
  '&:hover': {
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
  },
}))

const BrandHeader = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'accentColor',
})(({ theme, accentColor }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(3),
  cursor: 'pointer',
  position: 'relative',
  zIndex: 1,
  backgroundColor: accentColor?.accent || theme.palette.grey[50],
  transition: 'background-color 0.2s ease',
  '&:hover': {
    backgroundColor: accentColor?.accent?.replace('15', '25') || theme.palette.grey[100],
  },
}))

const LocationContent = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2, 2.5),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
}))

const StyledDrawer = styled(Drawer)(({ theme }) => ({
  '& .MuiDrawer-paper': {
    width: 900,
    maxWidth: '95vw',
    boxShadow: '-4px 0 24px rgba(0,0,0,0.15)',
    [theme.breakpoints.down('md')]: {
      width: '95vw',
    },
  },
}))

const PractitionerCard = styled(Paper)(({ theme, type }) => ({
  padding: theme.spacing(2.5),
  marginBottom: theme.spacing(2),
  borderRadius: theme.spacing(2),
  borderLeft: `4px solid ${
    type === 'doctor'
      ? theme.palette.error.main
      : type === 'therapist'
        ? theme.palette.info.main
        : theme.palette.warning.main
  }`,
  backgroundColor: theme.palette.background.paper,
  boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  transition: 'all 0.2s ease',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
  },
}))

const InfoRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  marginBottom: theme.spacing(1),
  '& .MuiSvgIcon-root': {
    fontSize: '1.1rem',
    color: theme.palette.text.secondary,
  },
}))

export default function ClinicsListing() {
  const navigate = useNavigate()
  const location = useLocation()
  const allRolesInBoolean = getAllRolesInBoolean()
  const [associatedClinics, setAssociatedClinics] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [expandedBrands, setExpandedBrands] = useState({})
  const [expandedLocations, setExpandedLocations] = useState({})
  // chamberRoomId -> latest occupancy status (batched per brand, see below)
  const [chamberRoomStatusById, setChamberRoomStatusById] = useState({})
  const [chamberStatusRefreshing, setChamberStatusRefreshing] = useState(false)
  const [practitionersDrawerOpen, setPractitionersDrawerOpen] = useState(false)
  const [brandPractitionersDrawerOpen, setBrandPractitionersDrawerOpen] = useState(false)
  const [locationDetailsDrawerOpen, setLocationDetailsDrawerOpen] = useState(false)
  const [selectedLocation, setSelectedLocation] = useState(null)
  const [selectedBrand, setSelectedBrand] = useState(null)
  const [selectedBrandData, setSelectedBrandData] = useState(null)
  const [practitioners, setPractitioners] = useState([])
  const [loadingPractitioners, setLoadingPractitioners] = useState(false)
  const [loadingBrandPractitioners, setLoadingBrandPractitioners] = useState(false)
  const [allMentors, setAllMentors] = useState([])
  const [savingAffiliationKeys, setSavingAffiliationKeys] = useState({})
  // Communications overview is now lazy — opened per-brand via a button into a drawer.
  const [communicationsDrawerBrand, setCommunicationsDrawerBrand] = useState(null)
  const [quotaDialogBrand, setQuotaDialogBrand] = useState(null)
  const canManageBrandCommsQuota =
    allRolesInBoolean.isClinicSuccessAdmin || allRolesInBoolean.isClinicSuccessManager
  const canManageClinicSchedule =
    allRolesInBoolean.isClinicSuccessAdmin || allRolesInBoolean.isClinicSuccessManager

  // OOH / kiosk screen management (admins + Clinic Success Admin/Manager only).
  const canManageOohScreens =
    allRolesInBoolean.isAdmin ||
    allRolesInBoolean.isClinicSuccessAdmin ||
    allRolesInBoolean.isClinicSuccessManager
  const [oohDrawerLocation, setOohDrawerLocation] = useState(null)
  const [kioskDrawerLocation, setKioskDrawerLocation] = useState(null)
  const [previewTarget, setPreviewTarget] = useState(null) // { clinicLocationId, mentorId }
  // People (workforce) management drawer: { scope:'brand'|'location', brandSlug, brandTitle, location }
  const [peopleManagerTarget, setPeopleManagerTarget] = useState(null)

  const uniqueBrands = useMemo(() => {
    return [
      ...new Map(
        associatedClinics?.map((item) => [
          item?.clinicBrandId,
          {
            id: item?.clinicBrandId,
            title: item?.clinicBrandName,
            ownerUserIds: item?.clinicBrandOwnerUserIds,
            slug: item?.clinicBrandSlug,
            // Bubbled up from ClinicBrand server-side; drives the specialty tabs below.
            targetSpecialitySlugs: Array.isArray(item?.clinicBrandTargetSpecialitySlugs)
              ? item.clinicBrandTargetSpecialitySlugs
              : [],
          },
        ]),
      ).values(),
    ]
  }, [associatedClinics])

  // Specialty tabs derived from the brands' targetSpecialitySlugs. One tab per distinct slug
  // present in the data, plus a synthetic "Not set" tab for brands with no slugs declared.
  const specialtyTabs = useMemo(() => {
    const slugSet = new Set()
    let hasUntagged = false
    uniqueBrands.forEach((brand) => {
      const slugs = Array.isArray(brand?.targetSpecialitySlugs) ? brand.targetSpecialitySlugs : []
      if (slugs.length === 0) {
        hasUntagged = true
        return
      }
      slugs.forEach((s) => {
        if (s) slugSet.add(s)
      })
    })
    const tabs = [{ id: 'all', label: 'All' }]
    Array.from(slugSet)
      .sort((a, b) => a.localeCompare(b))
      .forEach((s) =>
        tabs.push({
          id: `specialty-${s}`,
          slug: s,
          label: s
            .replace(/[-_]/g, ' ')
            .replace(/\b\w/g, (c) => c.toUpperCase()),
        }),
      )
    if (hasUntagged) tabs.push({ id: 'specialty-not-set', slug: null, label: 'Not Set' })
    return tabs
  }, [uniqueBrands])

  // Default to Psychiatry when the data has it; otherwise All. Only computed once on mount —
  // tab state is owned by the user from then on.
  const [selectedSpecialtyTab, setSelectedSpecialtyTab] = useState('all')

  useEffect(() => {
    if (selectedSpecialtyTab !== 'all') return
    if (!Array.isArray(specialtyTabs) || specialtyTabs.length === 0) return
    const psychiatry = specialtyTabs.find(
      (tab) => (tab.slug || '').toString().trim().toLowerCase() === 'psychiatry',
    )
    if (psychiatry) setSelectedSpecialtyTab(psychiatry.id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [specialtyTabs])

  const visibleBrands = useMemo(() => {
    if (selectedSpecialtyTab === 'all') return uniqueBrands
    if (selectedSpecialtyTab === 'specialty-not-set') {
      return uniqueBrands.filter(
        (b) => !Array.isArray(b?.targetSpecialitySlugs) || b.targetSpecialitySlugs.length === 0,
      )
    }
    const slug = selectedSpecialtyTab.replace(/^specialty-/, '')
    return uniqueBrands.filter(
      (b) => Array.isArray(b?.targetSpecialitySlugs) && b.targetSpecialitySlugs.includes(slug),
    )
  }, [uniqueBrands, selectedSpecialtyTab])

  const getLocationsForBrand = (brandId) => {
    return associatedClinics?.filter((clinic) => clinic?.clinicBrandId === brandId) || []
  }

  const getBrandAccent = (index) => {
    return brandAccentColors[index % brandAccentColors.length]
  }

  const getPractitionerIdentifier = (practitioner) =>
    practitioner?.id || practitioner?.uid || practitioner?.userId || practitioner?.email

  const matchesPractitioner = (contact, practitioner) => {
    if (!contact || !practitioner) {
      return false
    }
    const practitionerId = getPractitionerIdentifier(practitioner)
    return (
      contact?.uid === practitionerId ||
      contact?.uid === practitioner?.id ||
      contact?.userId === practitionerId ||
      contact?.userId === practitioner?.userId
    )
  }

  const getDefaultAffiliationLabel = (type) => {
    if (type === 'doctor') {
      return 'Consultations default to clinic-associated'
    }
    if (type === 'therapist') {
      return 'Therapy sessions default to AUMHUM network'
    }
    if (type === 'screener') {
      return 'Screenings default to AUMHUM network'
    }
    return 'Defaults depend on payout event type'
  }

  const getAffiliationOptionLabel = (value) => {
    if (value === AFFILIATION_BELONGS_TO_CLINIC) {
      return 'Clinic-associated'
    }
    if (value === AFFILIATION_BELONGS_TO_AUMHUM_NETWORK) {
      return 'AUMHUM network'
    }
    return 'Use default'
  }

  const getAffiliationScopeLabel = (scope) =>
    scope === PRACTITIONER_AFFILIATION_SCOPE_LOCATION ? 'Location override' : 'Brand default'

  const getAffiliationSaveKey = ({ scope, clinicBrandId, clinicLocationId, practitioner }) =>
    [scope, clinicBrandId || '', clinicLocationId || '', getPractitionerIdentifier(practitioner) || 'unknown'].join(':')

  const findMentorForContact = (contact) =>
    allMentors.find((mentor) => {
      if (!contact || !mentor) {
        return false
      }
      return (
        contact?.uid === mentor?.id ||
        contact?.uid === mentor?.uid ||
        contact?.userId === mentor?.userId
      )
    })

  const buildPractitionerFromContact = (contact, type, extra = {}) => {
    const mentor = findMentorForContact(contact)
    return {
      ...(contact || {}),
      ...(mentor || {}),
      id: mentor?.id || contact?.uid || contact?.id,
      uid: contact?.uid || mentor?.id || mentor?.uid,
      userId: contact?.userId || mentor?.userId,
      name: mentor?.name || contact?.title || mentor?.firstName || 'Unknown',
      title: contact?.title || mentor?.name || mentor?.firstName || 'Unknown',
      email: mentor?.email || contact?.email,
      phone: mentor?.phone || mentor?.mobile || contact?.mobile,
      mobile: mentor?.mobile || contact?.mobile,
      profilePicId: mentor?.profilePicId || contact?.profilePicId,
      specialization: mentor?.specialization,
      affiliationType: contact?.affiliationType || null,
      type,
      ...extra,
    }
  }

  const getPractitionerGroupsFromContacts = ({ doctors = [], therapists = [], screeners = [] } = {}, extra = {}) => ({
    doctors: doctors.map((contact) => buildPractitionerFromContact(contact, 'doctor', extra)),
    therapists: therapists.map((contact) => buildPractitionerFromContact(contact, 'therapist', extra)),
    screeners: screeners.map((contact) => buildPractitionerFromContact(contact, 'screener', extra)),
  })

  const flattenPractitionerGroups = (groups = {}) => [
    ...(groups?.doctors || []),
    ...(groups?.therapists || []),
    ...(groups?.screeners || []),
  ]

  const updateContactAffiliation = (contacts = [], practitioner, affiliationType) =>
    (contacts || []).map((contact) =>
      matchesPractitioner(contact, practitioner)
        ? {
            ...contact,
            affiliationType: affiliationType || null,
          }
        : contact,
    )

  const applyLocationAffiliationToLocation = (location, practitioner, affiliationType) => {
    if (!location) {
      return location
    }
    if (practitioner?.type === 'doctor') {
      return {
        ...location,
        doctors: updateContactAffiliation(location?.doctors, practitioner, affiliationType),
      }
    }
    if (practitioner?.type === 'therapist') {
      return {
        ...location,
        therapists: updateContactAffiliation(location?.therapists, practitioner, affiliationType),
      }
    }
    if (practitioner?.type === 'screener') {
      return {
        ...location,
        screeners: updateContactAffiliation(location?.screeners, practitioner, affiliationType),
      }
    }
    return location
  }

  const applyBrandAffiliationToBrand = (brandData, practitioner, affiliationType) => {
    if (!brandData) {
      return brandData
    }
    const workforce = brandData?.workforce || {}
    if (practitioner?.type === 'doctor') {
      return {
        ...brandData,
        workforce: {
          ...workforce,
          doctors: updateContactAffiliation(workforce?.doctors, practitioner, affiliationType),
        },
      }
    }
    if (practitioner?.type === 'therapist') {
      return {
        ...brandData,
        workforce: {
          ...workforce,
          therapists: updateContactAffiliation(workforce?.therapists, practitioner, affiliationType),
        },
      }
    }
    if (practitioner?.type === 'screener') {
      return {
        ...brandData,
        workforce: {
          ...workforce,
          screeners: updateContactAffiliation(workforce?.screeners, practitioner, affiliationType),
        },
      }
    }
    return brandData
  }

  async function getAllMentors() {
    try {
      const resp = await getSPDataWithParams(
        '/api/secure/cc/support/mentors/list',
        {
          mentorEventTypes: 'therapy-session,consultation,screening',
          sendAssociatedChambers: false,
        },
        undefined,
        undefined,
        true,
      )
      if (resp && isCommonResponseSuccessfulV2(resp)) {
        const mentors = getDataMapFromCommonResponse(resp)?.mentor || []
        setAllMentors(mentors)
      }
    } catch (error) {
      console.error('Error fetching mentors:', error)
    }
  }

  async function getAssociatedBrands() {
    setIsLoading(true)
    try {
      const resp = await getSPDataWithParams(
        '/api/secure/cc/support/clinics-with-brands/list',
        {},
        undefined,
        undefined,
        true,
      )
      if (resp && isCommonResponseSuccessfulV2(resp)) {
        const dat = getDataMapFromCommonResponse(resp)?.clinic || []
        setAssociatedClinics(dat)
        // Auto-expand first brand
        if (dat.length > 0) {
          const firstBrandId = dat[0]?.clinicBrandId
          setExpandedBrands({ [firstBrandId]: true })
        }
      }
    } catch (error) {
      console.error('Error fetching clinics:', error)
    } finally {
      setIsLoading(false)
    }
  }

  // Get practitioners from location object using already-loaded mentors
  function getPractitionersForLocation(location) {
    setLoadingPractitioners(true)

    try {
      const groups = getPractitionerGroupsFromContacts(
        {
          doctors: location?.doctors || [],
          therapists: location?.therapists || [],
          screeners: location?.screeners || [],
        },
        {
          clinicBrandId: location?.clinicBrandId,
          clinicLocationId: location?.id,
          affiliationScope: PRACTITIONER_AFFILIATION_SCOPE_LOCATION,
        },
      )
      setPractitioners(flattenPractitionerGroups(groups))
    } catch (error) {
      console.error('Error processing practitioners:', error)
      setPractitioners([])
    } finally {
      setLoadingPractitioners(false)
    }
  }

  async function loadBrandPractitioners(brand) {
    if (!brand?.slug) {
      toast.error('Clinic brand slug not found')
      return
    }

    setSelectedBrand(brand)
    setSelectedBrandData(null)
    setBrandPractitionersDrawerOpen(true)
    setLoadingBrandPractitioners(true)

    try {
      const resp = await getSupportClinicBrandBySlug(brand.slug)
      if (resp && isCommonResponseSuccessfulV2(resp)) {
        const brandData = getDataMapFromCommonResponse(resp)?.['clinic-brand']
        setSelectedBrandData(brandData)
      } else {
        setSelectedBrandData(null)
        toast.error(getMessageMapFromCommonResponse(resp) || 'Failed to load clinic brand practitioners')
      }
    } catch (error) {
      console.error('Error loading clinic brand practitioners:', error)
      setSelectedBrandData(null)
      toast.error('Failed to load clinic brand practitioners')
    } finally {
      setLoadingBrandPractitioners(false)
    }
  }

  const closeBrandPractitionersDrawer = () => {
    setBrandPractitionersDrawerOpen(false)
    setLoadingBrandPractitioners(false)
    setSelectedBrand(null)
    setSelectedBrandData(null)
  }

  async function handleAffiliationChange({
    practitioner,
    scope,
    clinicBrandId,
    clinicLocationId,
    affiliationType,
  }) {
    const saveKey = getAffiliationSaveKey({
      scope,
      clinicBrandId,
      clinicLocationId,
      practitioner,
    })

    setSavingAffiliationKeys((prev) => ({ ...prev, [saveKey]: true }))
    try {
      const resp = await updateSupportClinicPractitionerAffiliation({
        clinicBrandId,
        clinicLocationId:
          scope === PRACTITIONER_AFFILIATION_SCOPE_LOCATION ? clinicLocationId : undefined,
        mentorId: getPractitionerIdentifier(practitioner),
        affiliationType,
      })

      if (resp && isCommonResponseSuccessfulV2(resp)) {
        if (scope === PRACTITIONER_AFFILIATION_SCOPE_LOCATION) {
          setAssociatedClinics((prev) =>
            prev.map((location) =>
              location?.id === clinicLocationId
                ? applyLocationAffiliationToLocation(location, practitioner, affiliationType)
                : location,
            ),
          )
          setSelectedLocation((prev) =>
            prev?.id === clinicLocationId
              ? applyLocationAffiliationToLocation(prev, practitioner, affiliationType)
              : prev,
          )
          setPractitioners((prev) =>
            prev.map((item) =>
              getPractitionerIdentifier(item) === getPractitionerIdentifier(practitioner)
                ? { ...item, affiliationType: affiliationType || null }
                : item,
            ),
          )
        } else {
          setSelectedBrandData((prev) => applyBrandAffiliationToBrand(prev, practitioner, affiliationType))
        }
        toast.success(`Updated ${practitioner?.name || 'practitioner'} affiliation`)
      } else {
        toast.error(getMessageMapFromCommonResponse(resp) || 'Failed to update practitioner affiliation')
      }
    } catch (error) {
      console.error('Error updating practitioner affiliation:', error)
      toast.error('Failed to update practitioner affiliation')
    } finally {
      setSavingAffiliationKeys((prev) => ({ ...prev, [saveKey]: false }))
    }
  }

  useEffect(() => {
    // Load both clinics and mentors in parallel
    Promise.all([getAssociatedBrands(), getAllMentors()])
  }, [])

  const toggleBrand = (brandId) => {
    setExpandedBrands((prev) => ({
      ...prev,
      [brandId]: !prev[brandId],
    }))
  }

  const toggleLocation = (locationId) => {
    setExpandedLocations((prev) => ({
      ...prev,
      [locationId]: !prev[locationId],
    }))
  }

  // --- Batched chamber-room occupancy status -------------------------------
  // The /chamber-rooms/status endpoint returns ALL of a brand's chamber-room
  // statuses (each tagged with its clinicLocationId) when called with only a
  // clinicBrandId. So instead of every location's ChamberRoomsExpansion firing
  // its own per-location request (N calls + N polling intervals, some of which
  // 4061-fail for out-of-scope locations), we fetch once per expanded brand and
  // distribute the status map down to each location.
  const expandedBrandIds = useMemo(
    () => Object.keys(expandedBrands).filter((id) => expandedBrands[id]),
    [expandedBrands],
  )

  const fetchChamberStatusForBrands = useCallback(async (brandIds) => {
    if (!brandIds || brandIds.length === 0) return
    setChamberStatusRefreshing(true)
    try {
      const results = await Promise.all(
        brandIds.map((brandId) =>
          getSPDataWithParams('/api/secure/cc/support/csm/chamber-rooms/status', {
            clinicBrandId: brandId,
          })
            .then((resp) =>
              resp && isCommonResponseSuccessfulV2(resp)
                ? getDataMapFromCommonResponse(resp)?.chamberRoomStatus || []
                : [],
            )
            .catch((err) => {
              console.error('Error fetching chamber room status for brand', brandId, err)
              return []
            }),
        ),
      )
      setChamberRoomStatusById((prev) => {
        const next = { ...prev }
        results.flat().forEach((status) => {
          if (status?.chamberRoomId) {
            next[status.chamberRoomId] = status
          }
        })
        return next
      })
    } finally {
      setChamberStatusRefreshing(false)
    }
  }, [])

  useEffect(() => {
    if (expandedBrandIds.length === 0) return undefined
    fetchChamberStatusForBrands(expandedBrandIds)
    const interval = setInterval(() => {
      fetchChamberStatusForBrands(expandedBrandIds)
    }, 30000)
    return () => clearInterval(interval)
  }, [expandedBrandIds, fetchChamberStatusForBrands])

  const refreshChamberStatus = useCallback(
    () => fetchChamberStatusForBrands(expandedBrandIds),
    [fetchChamberStatusForBrands, expandedBrandIds],
  )

  const handlePractitionersClick = (location) => {
    setSelectedLocation(location)
    setPractitionersDrawerOpen(true)
    getPractitionersForLocation(location)
  }

  // Re-process practitioners when allMentors loads or selectedLocation changes
  useEffect(() => {
    if (practitionersDrawerOpen && selectedLocation && allMentors.length > 0) {
      getPractitionersForLocation(selectedLocation)
    }
  }, [allMentors, practitionersDrawerOpen, selectedLocation])

  const handleLocationNameClick = (location) => {
    setSelectedLocation(location)
    setLocationDetailsDrawerOpen(true)
  }

  const getPractitionerIcon = (type) => {
    switch (type) {
      case 'doctor':
        return <MedicalServices />
      case 'therapist':
        return <Psychology />
      case 'screener':
        return <PersonSearch />
      default:
        return <People />
    }
  }

  const getPractitionerColor = (type) => {
    switch (type) {
      case 'doctor':
        return 'error'
      case 'therapist':
        return 'info'
      case 'screener':
        return 'warning'
      default:
        return 'default'
    }
  }

  const AffiliationEditor = ({ practitioner, scope, clinicBrandId, clinicLocationId }) => {
    const saveKey = getAffiliationSaveKey({
      scope,
      clinicBrandId,
      clinicLocationId,
      practitioner,
    })
    const isSaving = Boolean(savingAffiliationKeys[saveKey])
    const defaultLabel = getDefaultAffiliationLabel(practitioner?.type)

    return (
      <Box
        sx={{
          mt: 2,
          p: 1.5,
          borderRadius: 2,
          backgroundColor: alpha('#0f172a', 0.03),
          border: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
          <Typography variant="subtitle2" fontWeight={600}>
            Payout affiliation
          </Typography>
          <Chip
            label={getAffiliationScopeLabel(scope)}
            size="small"
            variant="outlined"
            color={scope === PRACTITIONER_AFFILIATION_SCOPE_LOCATION ? 'primary' : 'default'}
          />
          {isSaving ? <Chip label="Saving..." size="small" color="warning" /> : null}
        </Stack>

        <FormControl fullWidth size="small" disabled={isSaving}>
          <InputLabel id={`${saveKey}-affiliation-label`}>Affiliation</InputLabel>
          <Select
            labelId={`${saveKey}-affiliation-label`}
            label="Affiliation"
            value={practitioner?.affiliationType || ''}
            onChange={(event) =>
              handleAffiliationChange({
                practitioner,
                scope,
                clinicBrandId,
                clinicLocationId,
                affiliationType: event.target.value,
              })
            }
          >
            <MenuItem value="">
              Use default
            </MenuItem>
            <MenuItem value={AFFILIATION_BELONGS_TO_AUMHUM_NETWORK}>
              AUMHUM network
            </MenuItem>
            <MenuItem value={AFFILIATION_BELONGS_TO_CLINIC}>
              Clinic-associated
            </MenuItem>
          </Select>
        </FormControl>

        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
          Current: {getAffiliationOptionLabel(practitioner?.affiliationType)}. {defaultLabel}.
        </Typography>
      </Box>
    )
  }

  // Brand-level actions
  const BrandActions = ({ brand, accentColor }) => {
    const basePath = '/support-home/clinics-hospitals/clinics'
    return (
      <Stack direction="row" spacing={1} onClick={(e) => e.stopPropagation()}>
        <Tooltip title="Brand Practitioners">
          <ActionButton
            variant="contained"
            size="small"
            startIcon={<People />}
            onClick={() => loadBrandPractitioners(brand)}
            sx={{
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: '#fff',
              '&:hover': {
                background: 'linear-gradient(135deg, #764ba2 0%, #667eea 100%)',
              },
            }}
          >
            Practitioners
          </ActionButton>
        </Tooltip>
        <Tooltip title="Manage brand people (add / remove practitioners)">
          <ActionButton
            variant="outlined"
            size="small"
            startIcon={<ManageAccounts />}
            onClick={() =>
              setPeopleManagerTarget({
                scope: 'brand',
                brandId: brand?.id,
                brandSlug: brand?.slug,
                brandTitle: brand?.title,
              })
            }
            sx={{
              borderColor: accentColor.border,
              color: accentColor.border,
              '&:hover': { borderColor: accentColor.border, backgroundColor: accentColor.accent },
            }}
          >
            People
          </ActionButton>
        </Tooltip>
        <Tooltip title="Patients">
          <ActionButton
            variant="contained"
            size="small"
            startIcon={<GroupIcon />}
            onClick={() => {
              navigate(`${basePath}/${brand?.slug}/patients`)
              sessionStorage.setItem('supportClinicBrandData', JSON.stringify(brand))
            }}
            sx={{
              background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
              color: '#fff',
              '&:hover': {
                background: 'linear-gradient(135deg, #f5576c 0%, #f093fb 100%)',
              },
            }}
          >
            Patients
          </ActionButton>
        </Tooltip>
        <Tooltip title="Brand Bundle Packs">
          <ActionButton
            variant="outlined"
            size="small"
            startIcon={<Business />}
            onClick={() => {
              navigate(basePath + "/" + (brand?.slug || "") + "/brand-bundle-packs")
              sessionStorage.setItem("supportClinicBrandData", JSON.stringify(brand))
            }}
            sx={{ 
              borderColor: accentColor.border,
              color: accentColor.border,
              '&:hover': { 
                borderColor: accentColor.border,
                backgroundColor: accentColor.accent,
              } 
            }}
          >
            Brand Bundles
          </ActionButton>
        </Tooltip>
        <Tooltip title="Payout Reports">
          <ActionButton
            variant="outlined"
            size="small"
            startIcon={<TrendingUp />}
            onClick={() => navigate(`${basePath}/${brand?.slug}/payout-reports`)}
            sx={{ 
              borderColor: accentColor.border,
              color: accentColor.border,
              '&:hover': { 
                borderColor: accentColor.border,
                backgroundColor: accentColor.accent,
              } 
            }}
          >
            Reports
          </ActionButton>
        </Tooltip>
        {canManageBrandCommsQuota ? (
          <Tooltip title="Communication Quota">
            <ActionButton
              variant="outlined"
              size="small"
              startIcon={<ContactPhone />}
              onClick={() => setQuotaDialogBrand(brand)}
              sx={{
                borderColor: accentColor.border,
                color: accentColor.border,
                '&:hover': {
                  borderColor: accentColor.border,
                  backgroundColor: accentColor.accent,
                },
              }}
            >
              Comms Quota
            </ActionButton>
          </Tooltip>
        ) : null}
        {canManageBrandCommsQuota ? (
          <Tooltip title="Patient Communication Policy">
            <ActionButton
              variant="outlined"
              size="small"
              startIcon={<Settings />}
              onClick={() => {
                navigate(`${basePath}/${brand?.slug || brand?.id}/communication-policy`)
                sessionStorage.setItem('supportClinicBrandData', JSON.stringify(brand))
              }}
              sx={{
                borderColor: accentColor.border,
                color: accentColor.border,
                '&:hover': {
                  borderColor: accentColor.border,
                  backgroundColor: accentColor.accent,
                },
              }}
            >
              Policy
            </ActionButton>
          </Tooltip>
        ) : null}
        <Tooltip title="Communications Overview">
          <ActionButton
            variant="outlined"
            size="small"
            startIcon={<Forum />}
            onClick={() => setCommunicationsDrawerBrand(brand)}
            sx={{
              borderColor: accentColor.border,
              color: accentColor.border,
              '&:hover': { borderColor: accentColor.border, backgroundColor: accentColor.accent },
            }}
          >
            Communications
          </ActionButton>
        </Tooltip>
        <Tooltip title="Engagement Models">
          <ActionButton
            variant="outlined"
            size="small"
            startIcon={<Assignment />}
            onClick={() => navigate(`${basePath}/${brand?.slug}/engagement-models`)}
            sx={{ 
              borderColor: accentColor.border,
              color: accentColor.border,
              '&:hover': { 
                borderColor: accentColor.border,
                backgroundColor: accentColor.accent,
              } 
            }}
          >
            Models
          </ActionButton>
        </Tooltip>
        <Tooltip title="Payout Invoices">
          <ActionButton
            variant="outlined"
            size="small"
            startIcon={<Receipt />}
            onClick={() => navigate(`${basePath}/${brand?.slug}/payout-invoices`)}
            sx={{ 
              borderColor: accentColor.border,
              color: accentColor.border,
              '&:hover': { 
                borderColor: accentColor.border,
                backgroundColor: accentColor.accent,
              } 
            }}
          >
            Invoices
          </ActionButton>
        </Tooltip>
      </Stack>
    )
  }

  // Location-level actions: use slug for URL when available, else id (API may not return slug for location)
  const getLocationSlugOrId = (location) => location?.slug ?? location?.clinicLocationSlug ?? location?.id ?? ''

  const LocationActions = ({ location }) => {
    const basePath = '/support-home/clinics-hospitals/clinics'
    const slugOrId = getLocationSlugOrId(location)
    return (
      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
        <ActionButton
          variant="contained"
          size="small"
          color="primary"
          startIcon={<CalendarToday />}
          onClick={() => {
            if (slugOrId) {
              navigate(`${basePath}/${slugOrId}/appointments`)
              sessionStorage.setItem('supportClinicData', JSON.stringify(location))
            }
          }}
          sx={{
            backgroundColor: 'rgba(16, 185, 129, 0.95)',
            '&:hover': {
              backgroundColor: 'rgba(16, 185, 129, 1)',
            },
          }}
        >
          Appointments
        </ActionButton>
        {canManageClinicSchedule ? (
          <ActionButton
            variant="outlined"
            size="small"
            color="success"
            startIcon={<Schedule />}
            disabled={!location?.id}
            onClick={() => {
              if (location?.id) {
                navigate(`${basePath}/${location.id}/schedule`)
                sessionStorage.setItem('supportClinicData', JSON.stringify(location))
              }
            }}
          >
            Set Schedule
          </ActionButton>
        ) : null}
        <ActionButton
          variant="contained"
          size="small"
          color="primary"
          startIcon={<Settings />}
          onClick={() => {
            if (slugOrId) {
              navigate(`${basePath}/${slugOrId}/services`)
              sessionStorage.setItem('supportClinicData', JSON.stringify(location))
            }
          }}
        >
          Services
        </ActionButton>
        <ActionButton
          variant="outlined"
          size="small"
          color="primary"
          startIcon={<Business />}
          onClick={() => {
            if (slugOrId) {
              navigate(basePath + "/" + slugOrId + "/bundle-packs")
              sessionStorage.setItem('supportClinicData', JSON.stringify(location))
            }
          }}
        >
          Bundle Packs
        </ActionButton>
        <ActionButton
          variant="outlined"
          size="small"
          color="primary"
          startIcon={<CalendarToday />}
          onClick={() => {
            if (slugOrId) {
              navigate(`${basePath}/${slugOrId}/unassigned-bookings`)
              sessionStorage.setItem('supportClinicData', JSON.stringify(location))
            }
          }}
        >
          Bookings
        </ActionButton>
        <ActionButton
          variant="contained"
          size="small"
          color="secondary"
          startIcon={<People />}
          onClick={() => handlePractitionersClick(location)}
          sx={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            '&:hover': {
              background: 'linear-gradient(135deg, #764ba2 0%, #667eea 100%)',
            },
          }}
        >
          Practitioners
        </ActionButton>
        <ActionButton
          variant="outlined"
          size="small"
          color="secondary"
          startIcon={<ManageAccounts />}
          onClick={() =>
            setPeopleManagerTarget({
              scope: 'location',
              brandId: location?.clinicBrandId,
              brandSlug: location?.clinicBrandSlug,
              brandTitle: location?.clinicBrandName,
              location,
            })
          }
        >
          People
        </ActionButton>
        <ActionButton
          variant="contained"
          size="small"
          color="primary"
          startIcon={<MedicalServices />}
          onClick={() => {
            navigate(`/support-home/prescription-interventions?clinicLocationId=${location?.id}&clinicLocationSlug=${getLocationSlugOrId(location)}`)
          }}
          sx={{
            backgroundColor: 'rgba(16, 185, 129, 0.95)',
            '&:hover': {
              backgroundColor: 'rgba(16, 185, 129, 1)',
            },
          }}
        >
          Interventions Requested
        </ActionButton>
        {canManageOohScreens && (
          <>
            <ActionButton
              variant="outlined"
              size="small"
              color="primary"
              startIcon={<Tv />}
              onClick={() => setKioskDrawerLocation(location)}
            >
              Kiosks
            </ActionButton>
            <ActionButton
              variant="outlined"
              size="small"
              color="primary"
              startIcon={<MonitorIcon />}
              onClick={() => setOohDrawerLocation(location)}
            >
              OOH
            </ActionButton>
          </>
        )}
      </Stack>
    )
  }

  const BrandPractitionersDrawer = () => {
    const practitionerGroups = getPractitionerGroupsFromContacts(
      {
        doctors: selectedBrandData?.workforce?.doctors || [],
        therapists: selectedBrandData?.workforce?.therapists || [],
        screeners: selectedBrandData?.workforce?.screeners || [],
      },
      {
        clinicBrandId: selectedBrandData?.id || selectedBrand?.id,
        affiliationScope: PRACTITIONER_AFFILIATION_SCOPE_BRAND,
      },
    )

    const renderSection = (title, items, color, type) => {
      if (!items.length) {
        return null
      }

      return (
        <Box sx={{ mb: 4 }}>
          <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 2 }}>
            <Typography variant="h6" fontWeight={600}>
              {title}
            </Typography>
            <Chip label={items.length} size="small" color={color} />
          </Stack>
          <Stack spacing={2}>
            {items.map((practitioner) => (
              <PractitionerCard key={getPractitionerIdentifier(practitioner)} type={type}>
                <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
                  <Avatar
                    src={getImageLink(practitioner?.profilePicId)}
                    sx={{
                      width: 56,
                      height: 56,
                      border: `2px solid ${
                        type === 'doctor'
                          ? 'error.main'
                          : type === 'therapist'
                            ? 'info.main'
                            : 'warning.main'
                      }`,
                    }}
                  >
                    {practitioner?.name?.charAt(0)?.toUpperCase() || '?'}
                  </Avatar>
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography variant="subtitle1" fontWeight={600}>
                      {practitioner?.name || 'Unknown'}
                    </Typography>
                    {practitioner?.specialization ? (
                      <Typography variant="body2" color="text.secondary">
                        {practitioner.specialization}
                      </Typography>
                    ) : null}
                    <Chip
                      icon={getPractitionerIcon(type)}
                      label={type === 'doctor' ? 'Doctor' : type === 'therapist' ? 'Therapist' : 'Screener'}
                      color={getPractitionerColor(type)}
                      size="small"
                      sx={{ mt: 1 }}
                    />
                    <AffiliationEditor
                      practitioner={practitioner}
                      scope={PRACTITIONER_AFFILIATION_SCOPE_BRAND}
                      clinicBrandId={selectedBrandData?.id || selectedBrand?.id}
                    />
                  </Box>
                </Box>
              </PractitionerCard>
            ))}
          </Stack>
        </Box>
      )
    }

    return (
      <StyledDrawer
        anchor="right"
        open={brandPractitionersDrawerOpen}
        onClose={closeBrandPractitionersDrawer}
      >
        <Box sx={{ width: 560, maxWidth: '95vw', height: '100%', display: 'flex', flexDirection: 'column' }}>
          <Box
            sx={{
              p: 3,
              background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
              borderBottom: '2px solid',
              borderColor: 'divider',
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
              <Typography variant="h5" fontWeight={600}>
                Brand Practitioners
              </Typography>
              <IconButton onClick={closeBrandPractitionersDrawer} size="small">
                <Close />
              </IconButton>
            </Box>
            <Typography variant="body2" color="text.secondary" fontWeight={500}>
              {selectedBrandData?.brandName || selectedBrand?.title}
            </Typography>
          </Box>

          <Box sx={{ flex: 1, overflow: 'auto', p: 3 }}>
            <Alert severity="info" sx={{ mb: 3 }}>
              Brand affiliation is the default for payout reporting. A location-level setting can override it for a specific clinic location.
            </Alert>

            {loadingBrandPractitioners ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '240px' }}>
                <CircularProgress />
              </Box>
            ) : (
              <>
                {renderSection('Doctors', practitionerGroups.doctors, 'error', 'doctor')}
                {renderSection('Therapists', practitionerGroups.therapists, 'info', 'therapist')}
                {renderSection('Screeners', practitionerGroups.screeners, 'warning', 'screener')}
                {flattenPractitionerGroups(practitionerGroups).length === 0 ? (
                  <Typography variant="body2" color="text.secondary">
                    No practitioners found in this clinic brand.
                  </Typography>
                ) : null}
              </>
            )}
          </Box>
        </Box>
      </StyledDrawer>
    )
  }

  // Practitioners Drawer Component
  const PractitionersDrawer = () => {
    const doctors = practitioners.filter((p) => p.type === 'doctor')
    const therapists = practitioners.filter((p) => p.type === 'therapist')
    const screeners = practitioners.filter((p) => p.type === 'screener')

    const listableEventTypes = (practitioner) =>
      getClinicPublicallyListableEvents(practitioner?.eventTypes, selectedLocation?.id) ||
      practitioner?.eventTypes?.filter((et) => et?.enabled && et?.publicEvent) ||
      []

    const getPublicBookingUrl = (practitioner, eventType) => {
      const base = APP_CONSTANTS.LIVE_APP_URL || window.location.origin
      const brandSlug = selectedLocation?.clinicBrandSlug
      const clinicId = selectedLocation?.id
      const mentorSlug = practitioner?.slug
      const eventId = eventType?.uid || eventType?.id
      if (!brandSlug || !clinicId || !mentorSlug || !eventId) return null
      return `${base}/clinic/${brandSlug}/id/${clinicId}/${mentorSlug}/${eventId}`
    }

    const PractitionerInfo = ({ practitioner, type }) => {
      const hasInfo = practitioner?.email || practitioner?.phone || practitioner?.slug
      const locationSlugOrId = getLocationSlugOrId(selectedLocation)
      const hasCalendarShortcut = locationSlugOrId && practitioner?.slug
      const eventTypesAtClinic = listableEventTypes(practitioner)

      return (
        <Accordion
          component={Paper}
          elevation={0}
          sx={{
            mb: 2,
            borderRadius: 2,
            borderLeft: `4px solid ${
              type === 'doctor'
                ? 'error.main'
                : type === 'therapist'
                  ? 'info.main'
                  : 'warning.main'
            }`,
            '&:before': { display: 'none' },
            overflow: 'hidden',
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMore />}
            sx={{ alignItems: 'flex-start', '& .MuiAccordionSummary-content': { my: 1.5 } }}
          >
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start', width: '100%', pr: 1 }}>
              <Avatar
                src={getImageLink(practitioner.profilePicId)}
                sx={{
                  width: 56,
                  height: 56,
                  border: `2px solid ${
                    type === 'doctor' ? 'error.main' : type === 'therapist' ? 'info.main' : 'warning.main'
                  }`,
                }}
              >
                {practitioner.name?.charAt(0)?.toUpperCase() || '?'}
              </Avatar>
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography variant="subtitle1" fontWeight={600}>
                  {practitioner.name || 'Unknown'}
                </Typography>
                {practitioner.specialization && (
                  <Typography variant="body2" color="text.secondary">
                    {practitioner.specialization}
                  </Typography>
                )}
                <Chip
                  icon={getPractitionerIcon(type)}
                  label={type === 'doctor' ? 'Doctor' : type === 'therapist' ? 'Therapist' : 'Screener'}
                  color={getPractitionerColor(type)}
                  size="small"
                  sx={{ mt: 1 }}
                />
              </Box>
            </Box>
          </AccordionSummary>
          <AccordionDetails sx={{ pt: 0, borderTop: '1px solid', borderColor: 'divider' }}>
            {hasCalendarShortcut && (
              <Box sx={{ mb: 2 }}>
                <Tooltip title="Open practitioner calendar at this location">
                  <Button
                    size="small"
                    variant="outlined"
                    startIcon={<CalendarToday />}
                    onClick={() => {
                      setPractitionersDrawerOpen(false)
                      navigate(
                        `/support-home/clinics-hospitals/clinics/${locationSlugOrId}/${practitioner.slug}`,
                      )
                    }}
                    sx={{ textTransform: 'none' }}
                  >
                    Open calendar
                  </Button>
                </Tooltip>
              </Box>
            )}

            {eventTypesAtClinic.length > 0 && (
              <Box sx={{ mb: 2 }}>
                <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ display: 'block', mb: 1 }}>
                  Event types at this location
                </Typography>
                <Stack spacing={1}>
                  {eventTypesAtClinic.map((eventType) => {
                    const bookingUrl = getPublicBookingUrl(practitioner, eventType)
                    const title = eventType?.title || eventType?.name || eventType?.uid || 'Session'
                    return (
                      <Box
                        key={eventType?.uid || eventType?.id || title}
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          gap: 1,
                          py: 0.75,
                          px: 1.5,
                          borderRadius: 1,
                          bgcolor: 'action.hover',
                        }}
                      >
                        <Typography variant="body2" fontWeight={500}>
                          {title}
                        </Typography>
                        {bookingUrl ? (
                          <Tooltip title="Open public booking page in new tab">
                            <IconButton
                              size="small"
                              color="primary"
                              component="a"
                              href={bookingUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              aria-label={`Open booking for ${title}`}
                            >
                              <OpenInNew fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        ) : null}
                      </Box>
                    )
                  })}
                </Stack>
              </Box>
            )}

            {eventTypesAtClinic.length === 0 && (practitioner?.eventTypes?.length > 0) && (
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                No public bookable event types at this location.
              </Typography>
            )}

            <AffiliationEditor
              practitioner={practitioner}
              scope={PRACTITIONER_AFFILIATION_SCOPE_LOCATION}
              clinicBrandId={selectedLocation?.clinicBrandId}
              clinicLocationId={selectedLocation?.id}
            />

            {hasInfo && (
              <Box sx={{ pt: 1.5, borderTop: '1px solid', borderColor: 'divider' }}>
                {practitioner.email && (
                  <InfoRow>
                    <Email fontSize="small" />
                    <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>
                      {practitioner.email}
                    </Typography>
                  </InfoRow>
                )}
                {practitioner.phone && (
                  <InfoRow>
                    <Phone fontSize="small" />
                    <Typography variant="body2">{practitioner.phone}</Typography>
                  </InfoRow>
                )}
                {practitioner.slug && (
                  <InfoRow>
                    <Badge fontSize="small" />
                    <Typography variant="caption" color="text.secondary" sx={{ fontFamily: 'monospace' }}>
                      {practitioner.slug}
                    </Typography>
                  </InfoRow>
                )}
              </Box>
            )}
          </AccordionDetails>
        </Accordion>
      )
    }

    return (
      <StyledDrawer
        anchor="right"
        open={practitionersDrawerOpen}
        onClose={() => setPractitionersDrawerOpen(false)}
      >
        <Box sx={{ width: 520, maxWidth: '90vw', height: '100%', display: 'flex', flexDirection: 'column' }}>
          <Box
            sx={{
              p: 3,
              background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
              borderBottom: '2px solid',
              borderColor: 'divider',
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
              <Typography variant="h5" fontWeight={600} color="text.primary">
                Practitioners
              </Typography>
              <IconButton onClick={() => setPractitionersDrawerOpen(false)} size="small">
                <Close />
              </IconButton>
            </Box>
            <Typography variant="body2" color="text.secondary" fontWeight={500}>
              {selectedLocation?.title}
            </Typography>
          </Box>

	          <Box sx={{ flex: 1, overflow: 'auto', p: 3 }}>
	            <Alert severity="info" sx={{ mb: 3 }}>
	              Location affiliation overrides the clinic brand default for payout reporting at this clinic.
	            </Alert>
	            {loadingPractitioners ? (
	              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
	                <CircularProgress />
              </Box>
            ) : practitioners.length === 0 ? (
              <Box sx={{ textAlign: 'center', p: 4 }}>
                <People sx={{ fontSize: 64, color: 'text.secondary', mb: 2, opacity: 0.5 }} />
                <Typography variant="h6" color="text.secondary" gutterBottom>
                  No Practitioners Found
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  This location doesn&apos;t have any practitioners assigned yet.
                </Typography>
              </Box>
            ) : (
              <>
                {doctors.length > 0 && (
                  <Box sx={{ mb: 4 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
                      <MedicalServices sx={{ color: 'error.main', fontSize: 28 }} />
                      <Typography variant="h6" fontWeight={600}>
                        Doctors
                      </Typography>
                      <Chip 
                        label={doctors.length} 
                        size="small" 
                        color="error" 
                        sx={{ ml: 1 }}
                      />
                    </Box>
                    {doctors.map((practitioner) => (
                      <PractitionerInfo 
                        key={practitioner.id || practitioner.uid} 
                        practitioner={practitioner} 
                        type="doctor" 
                      />
                    ))}
                  </Box>
                )}

                {therapists.length > 0 && (
                  <Box sx={{ mb: 4 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
                      <Psychology sx={{ color: 'info.main', fontSize: 28 }} />
                      <Typography variant="h6" fontWeight={600}>
                        Therapists
                      </Typography>
                      <Chip 
                        label={therapists.length} 
                        size="small" 
                        color="info" 
                        sx={{ ml: 1 }}
                      />
                    </Box>
                    {therapists.map((practitioner) => (
                      <PractitionerInfo 
                        key={practitioner.id || practitioner.uid} 
                        practitioner={practitioner} 
                        type="therapist" 
                      />
                    ))}
                  </Box>
                )}

                {screeners.length > 0 && (
                  <Box sx={{ mb: 4 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
                      <PersonSearch sx={{ color: 'warning.main', fontSize: 28 }} />
                      <Typography variant="h6" fontWeight={600}>
                        Screeners
                      </Typography>
                      <Chip 
                        label={screeners.length} 
                        size="small" 
                        color="warning" 
                        sx={{ ml: 1 }}
                      />
                    </Box>
                    {screeners.map((practitioner) => (
                      <PractitionerInfo 
                        key={practitioner.id || practitioner.uid} 
                        practitioner={practitioner} 
                        type="screener" 
                      />
                    ))}
                  </Box>
                )}
              </>
            )}
          </Box>
        </Box>
      </StyledDrawer>
    )
  }

  // Get practitioners for location details drawer
  const getLocationPractitioners = (location) => {
    if (!location) return { doctors: [], therapists: [], screeners: [] }

    return getPractitionerGroupsFromContacts(
      {
        doctors: location?.doctors || [],
        therapists: location?.therapists || [],
        screeners: location?.screeners || [],
      },
      {
        clinicBrandId: location?.clinicBrandId,
        clinicLocationId: location?.id,
        affiliationScope: PRACTITIONER_AFFILIATION_SCOPE_LOCATION,
      },
    )
  }

  // Clinic Location Details Drawer
  const LocationDetailsDrawer = () => {
    if (!selectedLocation) return null

    const locationPractitioners = getLocationPractitioners(selectedLocation)
    const { doctors, therapists, screeners } = locationPractitioners

    const PractitionerGrid = ({ practitioners, type, icon: Icon, color }) => {
      if (practitioners.length === 0) {
        return (
          <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 2 }}>
            No {type} assigned to this location
          </Typography>
        )
      }

      return (
        <Grid container spacing={2}>
          {practitioners.map((practitioner) => (
            <Grid item xs={12} sm={6} lg={4} key={getPractitionerIdentifier(practitioner)}>
              <Paper
                sx={{
                  p: 2,
                  borderRadius: 2,
                  border: `2px solid ${color}40`,
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    borderColor: color,
                    transform: 'translateY(-2px)',
                    boxShadow: `0 4px 12px ${color}30`,
                  },
                }}
              >
                <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
                  <Avatar
                    src={getImageLink(practitioner.profilePicId)}
                    sx={{
                      width: 64,
                      height: 64,
                      border: `2px solid ${color}`,
                    }}
                  >
                    {practitioner.name?.charAt(0)?.toUpperCase() || '?'}
                  </Avatar>
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 0.5 }}>
                      {practitioner.name || 'Unknown'}
                    </Typography>
                    {practitioner.specialization && (
                      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
                        {practitioner.specialization}
                      </Typography>
                    )}
                    <Chip
                      icon={<Icon />}
                      label={type}
                      size="small"
                      sx={{
                        mt: 1,
                        backgroundColor: `${color}15`,
                        color: color,
                        border: `1px solid ${color}40`,
                      }}
                    />
                    <AffiliationEditor
                      practitioner={practitioner}
                      scope={PRACTITIONER_AFFILIATION_SCOPE_LOCATION}
                      clinicBrandId={selectedLocation?.clinicBrandId}
                      clinicLocationId={selectedLocation?.id}
                    />
                  </Box>
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>
      )
    }

    return (
      <StyledDrawer
        anchor="right"
        open={locationDetailsDrawerOpen}
        onClose={() => setLocationDetailsDrawerOpen(false)}
      >
        <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
          {/* Header */}
          <Box
            sx={{
              p: 3,
              background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
              borderBottom: '2px solid',
              borderColor: 'divider',
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
              <Typography variant="h5" fontWeight={600} color="text.primary">
                Clinic Location Details
              </Typography>
              <IconButton onClick={() => setLocationDetailsDrawerOpen(false)} size="small">
                <Close />
              </IconButton>
            </Box>
            <Typography variant="h6" color="text.primary" fontWeight={500}>
              {selectedLocation?.title || 'Unknown Location'}
            </Typography>
          </Box>

          {/* Content */}
          <Box sx={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', p: 3 }}>
            <Alert severity="info" sx={{ mb: 3 }}>
              Location affiliation overrides the clinic brand default for payout calculations at this clinic location.
            </Alert>
            {/* Basic Information Accordion */}
            <Accordion defaultExpanded sx={{ mb: 2, boxShadow: 2 }}>
              <AccordionSummary expandIcon={<ExpandMore />}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <Info color="primary" />
                  <Typography variant="h6" fontWeight={600}>
                    Basic Information
                  </Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Stack spacing={2}>
                  {selectedLocation?.address && (
                    <Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                        <Home fontSize="small" color="action" />
                        <Typography variant="subtitle2" color="text.secondary" fontWeight={600}>
                          Address
                        </Typography>
                      </Box>
                      <Typography variant="body1">{selectedLocation.address}</Typography>
                    </Box>
                  )}
                  
                  {(selectedLocation?.phone || selectedLocation?.email) && (
                    <Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                        <ContactPhone fontSize="small" color="action" />
                        <Typography variant="subtitle2" color="text.secondary" fontWeight={600}>
                          Contact Information
                        </Typography>
                      </Box>
                      <Stack spacing={1}>
                        {selectedLocation?.phone && (
                          <InfoRow>
                            <Phone fontSize="small" />
                            <Typography variant="body1">{selectedLocation.phone}</Typography>
                          </InfoRow>
                        )}
                        {selectedLocation?.email && (
                          <InfoRow>
                            <Email fontSize="small" />
                            <Typography variant="body1" sx={{ wordBreak: 'break-word' }}>
                              {selectedLocation.email}
                            </Typography>
                          </InfoRow>
                        )}
                      </Stack>
                    </Box>
                  )}

                  {selectedLocation?.clinicBrandName && (
                    <Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                        <Business fontSize="small" color="action" />
                        <Typography variant="subtitle2" color="text.secondary" fontWeight={600}>
                          Brand
                        </Typography>
                      </Box>
                      <Typography variant="body1" fontWeight={500}>
                        {selectedLocation.clinicBrandName}
                      </Typography>
                    </Box>
                  )}
                </Stack>
              </AccordionDetails>
            </Accordion>

            {/* Practitioners Accordion */}
            <Accordion defaultExpanded sx={{ mb: 2, boxShadow: 2 }}>
              <AccordionSummary expandIcon={<ExpandMore />}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <People color="primary" />
                  <Typography variant="h6" fontWeight={600}>
                    Practitioners
                  </Typography>
                  <Chip
                    label={doctors.length + therapists.length + screeners.length}
                    size="small"
                    color="primary"
                    sx={{ ml: 1 }}
                  />
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Stack spacing={3}>
                  {/* Doctors Section */}
                  <Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                      <MedicalServices color="error" />
                      <Typography variant="subtitle1" fontWeight={600}>
                        Doctors
                      </Typography>
                      <Chip label={doctors.length} size="small" color="error" sx={{ ml: 1 }} />
                    </Box>
                    <PractitionerGrid
                      practitioners={doctors}
                      type="Doctor"
                      icon={MedicalServices}
                      color="#d32f2f"
                    />
                  </Box>

                  <Divider />

                  {/* Therapists Section */}
                  <Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                      <Psychology color="info" />
                      <Typography variant="subtitle1" fontWeight={600}>
                        Therapists
                      </Typography>
                      <Chip label={therapists.length} size="small" color="info" sx={{ ml: 1 }} />
                    </Box>
                    <PractitionerGrid
                      practitioners={therapists}
                      type="Therapist"
                      icon={Psychology}
                      color="#0288d1"
                    />
                  </Box>

                  <Divider />

                  {/* Screeners Section */}
                  <Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                      <PersonSearch color="warning" />
                      <Typography variant="subtitle1" fontWeight={600}>
                        Screeners
                      </Typography>
                      <Chip label={screeners.length} size="small" color="warning" sx={{ ml: 1 }} />
                    </Box>
                    <PractitionerGrid
                      practitioners={screeners}
                      type="Screener"
                      icon={PersonSearch}
                      color="#ed6c02"
                    />
                  </Box>
                </Stack>
              </AccordionDetails>
            </Accordion>

            {/* Additional Information Accordion (if any) */}
            {Object.entries(selectedLocation || {})
              .filter(([key, value]) => {
                const excludedKeys = [
                  'id', 'title', 'address', 'phone', 'email', 'clinicBrandName',
                  'slug', 'clinicBrandId', 'clinicBrandSlug', 'doctors', 'therapists', 'screeners'
                ]
                return !excludedKeys.includes(key) && value && typeof value !== 'object'
              })
              .length > 0 && (
              <Accordion sx={{ boxShadow: 2 }}>
                <AccordionSummary expandIcon={<ExpandMore />}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <Info color="primary" />
                    <Typography variant="h6" fontWeight={600}>
                      Additional Information
                    </Typography>
                  </Box>
                </AccordionSummary>
                <AccordionDetails>
                  <Stack spacing={2}>
                    {Object.entries(selectedLocation || {})
                      .filter(([key, value]) => {
                        const excludedKeys = [
                          'id', 'title', 'address', 'phone', 'email', 'clinicBrandName',
                          'slug', 'clinicBrandId', 'clinicBrandSlug', 'doctors', 'therapists', 'screeners'
                        ]
                        return !excludedKeys.includes(key) && value && typeof value !== 'object'
                      })
                      .map(([key, value]) => (
                        <Box key={key}>
                          <Typography variant="subtitle2" color="text.secondary" fontWeight={600} gutterBottom>
                            {key
                              .replace(/([A-Z])/g, ' $1')
                              .replace(/^./, (str) => str.toUpperCase())
                              .trim()}
                          </Typography>
                          <Typography variant="body1">
                            {String(value)}
                          </Typography>
                        </Box>
                      ))}
                  </Stack>
                </AccordionDetails>
              </Accordion>
            )}
          </Box>
        </Box>
      </StyledDrawer>
    )
  }

  if (isLoading) {
    return (
      <>
        <SupportHeader heading="Clinics" showBackButton />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '400px',
          }}
        >
          <CircularProgress />
        </Box>
      </>
    )
  }

  return (
    <>
      <SupportHeader heading="Clinics" showBackButton />
      <Box sx={{ maxWidth: 1400, mx: 'auto', p: 3 }}>
        {/* Specialty tabs (Phase 8) — derived from each brand's targetSpecialitySlugs. The
            "All" tab is the default; "Not Set" is a synthetic tab catching brands with no
            specialty declared so they don't fall off the page. */}
        {specialtyTabs.length > 1 && (
          <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
            <Tabs
              value={selectedSpecialtyTab}
              onChange={(_e, next) => setSelectedSpecialtyTab(next)}
              variant="scrollable"
              scrollButtons="auto"
            >
              {specialtyTabs.map((tab) => (
                <Tab key={tab.id} value={tab.id} label={tab.label} />
              ))}
            </Tabs>
          </Box>
        )}

        {visibleBrands?.length === 0 ? (
          <Card sx={{ p: 4, textAlign: 'center' }}>
            <Typography variant="h6" color="text.secondary">
              {selectedSpecialtyTab === 'all'
                ? 'No clinics found'
                : 'No clinics for this specialty'}
            </Typography>
          </Card>
        ) : (
          visibleBrands
            ?.sort((a, b) => a.title?.localeCompare(b.title))
            ?.map((brand, brandIndex) => {
              const locations = getLocationsForBrand(brand.id)
              const isBrandExpanded = expandedBrands[brand.id]
              const brandAccent = getBrandAccent(brandIndex)

              return (
                <StyledBrandCard key={brand.id} accentColor={brandAccent}>
                  <BrandHeader onClick={() => toggleBrand(brand.id)} accentColor={brandAccent}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: 1 }}>
                      <Business sx={{ fontSize: 36, color: brandAccent.icon }} />
                      <Box sx={{ flex: 1 }}>
                        <Typography variant="h5" fontWeight={600} color="text.primary">
                          {brand.title}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          {locations.length} location{locations.length !== 1 ? 's' : ''}
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <BrandActions brand={brand} accentColor={brandAccent} />
                      <IconButton size="medium" sx={{ color: brandAccent.icon }}>
                        {isBrandExpanded ? <ExpandLess /> : <ExpandMore />}
                      </IconButton>
                    </Box>
                  </BrandHeader>

                  <Collapse in={isBrandExpanded}>
                    <CardContent sx={{ pt: 0, pb: 2, backgroundColor: 'background.paper' }}>
                      {locations.length === 0 ? (
                        <Typography variant="body2" color="text.secondary" sx={{ p: 2 }}>
                          No locations found for this brand
                        </Typography>
                      ) : (
                        locations.map((location) => {
                          const isLocationExpanded = expandedLocations[location.id]

                          return (
                            <StyledLocationCard key={location.id}>
                              <LocationContent>
                                <Box
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1.5,
                                    flex: 1,
                                    cursor: 'pointer',
                                  }}
                                  onClick={() => handleLocationNameClick(location)}
                                >
                                  <LocationOn sx={{ color: 'primary.main', fontSize: 24 }} />
                                  <Box>
                                    <Typography variant="h6" fontWeight={600} color="primary">
                                      {location.title}
                                    </Typography>
                                    {location.address && (
                                      <Typography variant="caption" color="text.secondary">
                                        {location.address}
                                      </Typography>
                                    )}
                                  </Box>
                                </Box>
                                <Box
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                  }}
                                >
                                  <LocationActions location={location} />
                                  <IconButton
                                    size="small"
                                    onClick={() => toggleLocation(location.id)}
                                  >
                                    {isLocationExpanded ? <ExpandLess /> : <ExpandMore />}
                                  </IconButton>
                                </Box>
                              </LocationContent>
                              <Collapse in={isLocationExpanded}>
                                <Box sx={{ p: 2, pt: 0, backgroundColor: 'grey.50' }}>
                                  <Divider sx={{ mb: 2 }} />
                                  <ChamberRoomsExpansion
                                    clinicBrandId={location?.clinicBrandId}
                                    clinicLocationId={location?.id}
                                    clinicLocationTitle={location?.title}
                                    allMentors={allMentors}
                                    roomStatusById={chamberRoomStatusById}
                                    onRefreshStatus={refreshChamberStatus}
                                    statusRefreshing={chamberStatusRefreshing}
                                  />
                                </Box>
                              </Collapse>
                            </StyledLocationCard>
                          )
                        })
                      )}
                    </CardContent>
                  </Collapse>
                </StyledBrandCard>
              )
            })
        )}
      </Box>

      {/* Drawers */}
      <BrandPractitionersDrawer />
      <PractitionersDrawer />
      <LocationDetailsDrawer />
      <ClinicPeopleManagerDrawer
        open={Boolean(peopleManagerTarget)}
        onClose={() => setPeopleManagerTarget(null)}
        scope={peopleManagerTarget?.scope}
        brandId={peopleManagerTarget?.brandId}
        brandSlug={peopleManagerTarget?.brandSlug}
        brandTitle={peopleManagerTarget?.brandTitle}
        location={peopleManagerTarget?.location}
        mentors={allMentors}
        onChanged={getAssociatedBrands}
      />
      <ClinicBrandCommunicationsDrawer
        open={Boolean(communicationsDrawerBrand)}
        onClose={() => setCommunicationsDrawerBrand(null)}
        brand={communicationsDrawerBrand}
      />
      <ClinicBrandCommsQuotaDialog
        open={!!quotaDialogBrand}
        clinicBrand={quotaDialogBrand}
        onClose={() => setQuotaDialogBrand(null)}
      />
      <OohScreensDrawer
        open={!!oohDrawerLocation}
        clinicLocation={oohDrawerLocation}
        onClose={() => setOohDrawerLocation(null)}
        onPreview={(mentorId) =>
          setPreviewTarget({ clinicLocationId: oohDrawerLocation?.id, mentorId })
        }
      />
      <KioskScreensDrawer
        open={!!kioskDrawerLocation}
        clinicLocation={kioskDrawerLocation}
        onClose={() => setKioskDrawerLocation(null)}
      />
      <Drawer
        anchor="right"
        open={!!previewTarget}
        onClose={() => setPreviewTarget(null)}
        PaperProps={{ sx: { width: '100vw', maxWidth: '100vw' } }}
      >
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', background: '#0f1419' }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              px: 2,
              py: 1,
              background: '#1a2332',
              color: '#fff',
            }}
          >
            <Typography variant="subtitle1" fontWeight={700}>
              Screen Preview
            </Typography>
            <Button
              variant="contained"
              color="inherit"
              startIcon={<Close />}
              onClick={() => setPreviewTarget(null)}
              sx={{ color: '#1a2332', background: '#fff' }}
            >
              Close Preview
            </Button>
          </Box>
          {previewTarget && (
            <iframe
              title="OOH Screen Preview"
              src={`/ooh-preview/${previewTarget.clinicLocationId}/${previewTarget.mentorId}`}
              style={{ flex: 1, width: '100%', border: 'none' }}
            />
          )}
        </Box>
      </Drawer>
    </>
  )
}
